export default __webpack_public_path__ + "static/media/mascot-dice.904a6e1a.png";